import React from 'react';
import Card from '../../../components/card.component';
import ClientTable from './clientTable.component';

const Dashboard = () => {
  return (
    <Card>
     <ClientTable/>
    </Card>
  )
}

export default Dashboard;